import React from 'react';
import { Link } from 'react-router-dom';


const SupportCard = ({ 
  icon: Icon, 
  title, 
  description, 
  link, 
  categories = [],
  isFutureGift = false 
}) => {
  return (
    <Link 
      to={`/account/support/${link}`}
      className='  border-b-2 border-[#E4E4E4]'
    >
      <div className=" pb-7">
        <div className="flex items-start">
          {/* Icon Section - matches screenshot spacing */}
          <div className="flex-shrink-0 mr-3 mt-1">
            <Icon className="w-5 h-5 text-[#55000C]" />
          </div>
          
          {/* Content Section */}
          <div className="flex-1">
            {/* Title with exact screenshot styling */}
            <h3 className="text-base font-medium text-[#0E1628] mb-1">
              {title}
            </h3>
            
            {/* Description with exact screenshot text styling */}
            <p className="text-sm text-[#6B635D] leading-relaxed">
              {description}
            </p>
            
            {/* Categories/Tags - positioned exactly like screenshot */}
            {categories.length > 0 && (
              <div className="mt-3 flex flex-wrap gap-1">
                {categories.map((category, index) => (
                  <span 
                    key={index}
                    className="px-2 py-0.5 bg-[#F5F5F5] text-[#55000C] text-[10px] font-medium rounded-sm border border-[#E0E0E0]"
                  >
                    {category}
                  </span>
                ))}
              </div>
            )}
            
            {/* "Contact support" link - matches screenshot positioning */}
            {isFutureGift && (
              <div className="mt-4 pt-4 border-t border-[#E4E4E4]">
                <span className="text-xs text-[#55000C] font-medium hover:underline inline-flex items-center">
                  Contact support
                  <svg className="w-3 h-3 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default SupportCard;